import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsSolutions(tenant: Tenant): Faq[] {
	return [
		{
			question: "Kolik stojí IT řešení na míru?",
			answer:
				"Každou zakázku naceňujeme individuálně na základě potřeb zákazníka a rozsahu prací. Například realizace CRM začíná na 150 000 Kč, integrace systémů zhruba na 50 000 Kč a kiosek na míru děláme od 80 000 Kč.",
		},
		{
			question: "Jak probíhá úvodní konzultace?",
			answer:
				"Můžeme se s vámi potkat buď online na videohovoru, nebo si společně domluvíme osobní schůzku. V obou případech podrobně zanalyzujeme vaše potřeby a doporučíme vám ideální řešení.",
		},
		{
			question: "Co všechno pro mě zařídíte v oblasti CRM?",
			answer:
				"V rámci CRM poskytujeme komplexní služby. Vyřešíme za vás vývoj, audit, optimalizaci i implementaci nebo automatizaci CRM systému.",
		},
		{
			question: "Dokážete nám poskytnout IT specialistu, který bude na IT řešení pracovat přímo u nás ve firmě?",
			answer:
				"Ano, poskytujeme i pronájem IT specialistů, případně i celého týmu, a to dlouhodobý i krátkodobý (podle rozsahu a charakteru projektu).",
		},
	];
}
